module.exports = __webpack_public_path__ + "static/jewelry-85eb5e38ce89a5bd37284c30a3001c02.png";